import { routes } from '@p2p/shared/routing';
import { isRejected, type Middleware, type MiddlewareAPI } from '@reduxjs/toolkit';

export const errorCatcherMiddleware: Middleware =
  (api: MiddlewareAPI) => (next) => (action: any) => {
    if (isRejected(action)) {
      if (action.payload?.status >= 500 && action.payload?.status < 600) {
        window.location.href = routes.serverError.template;
      }
    }
    return next(action);
  };
